var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"u-margin-top-8x",attrs:{"data-cy":"saml-login"}},[_c('BaseStateIndicator',{attrs:{"state":_vm.state}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }